// extracted by mini-css-extract-plugin
module.exports = {"activeButton":"DownloadReport_activeButton__1Z16E","notActiveDropdown":"DownloadReport_notActiveDropdown__1cCb9"};